import { render, staticRenderFns } from "./AddTextarea.vue?vue&type=template&id=40fb9298&scoped=true&"
import script from "./AddTextarea.vue?vue&type=script&lang=js&"
export * from "./AddTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AddTextarea.vue?vue&type=style&index=0&id=40fb9298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb9298",
  null
  
)

export default component.exports